module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.6163/img/screenshot-og.png"